import React from "react";
import { twMerge } from "tailwind-merge";

import UiDetailsAtomLogoText from "@/components/Ui/Details/Atom/LogoText";

interface UiDetailsAtomLogoProps {
  logo?: string;
  subTitle?: string;
  title: string;
  className?: string;
}

export default function UiDetailsAtomLogo({ className, logo, title, subTitle }: UiDetailsAtomLogoProps) {
  const fullTitle = `${title}${subTitle ? `: ${subTitle}` : ""}`;

  return (
    <div className={twMerge("relative size-28 rounded-full border-0.5 border-neutral-900 bg-neutral p-6", className)}>
      <img className="size-full rounded-full object-cover" src={logo} alt={fullTitle} title={fullTitle} />
      <UiDetailsAtomLogoText text={title} className="absolute inset-0 z-10 h-28 w-28" />
    </div>
  );
}
